import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Bar from '../../../ui/Bar';
import Button from '../../../ui/Button';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/List.scss';
import {getAddressbooks, selectAddressbooks} from "../addressbooks";
import Table from "../../../ui/Table";
import TableRow from "../../../ui/TableRow";
import TableCell from "../../../ui/TableCell";
import Helmet from 'react-helmet';

@injectIntl
export class AddressbookList extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        intl: intlShape,
    }

    componentDidMount() {
        this.props.dispatch(getAddressbooks({}, { spinner: 'addressbook' }));
    }

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const { addressbooks } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Page.Body>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.addresses' })} />
                <Page.Section depth={0}>
                    <h1>
                        <FormattedMessage id='frontend.addressbook.headline.intro' />
                    </h1>
                    <Bar>
                        <Bar.Section float='right'>
                            <Button link to='/addressbook/new'>
                                <FormattedMessage id='addressbook.address.new_book' />
                            </Button>
                        </Bar.Section>
                    </Bar>
                </Page.Section>

                <Page.Section>
                    <Table>
                        <TableRow type='header' className={styles.headerRow}>
                            <TableCell className={styles.headerCell}>Name</TableCell>
                            <TableCell className={styles.headerCell}>Type</TableCell>
                            <TableCell className={styles.headerCell} />
                        </TableRow>

                        {Array.from(addressbooks.values()).map((addressbook,idx) =>
                            <TableRow key={idx} type='body' className={styles.row}>
                                <TableCell className={styles.cell}>{ addressbook.get('type') === 'addressbook.personal' ? (
                                    <FormattedMessage id='frontend.form_selector_addressbook.select.option.personal_addressbook' />
                                ) : addressbook.get('name') }</TableCell>
                                <TableCell className={styles.cell}>{ addressbook.get('type') === 'addressbook.personal'
                                    ? <FormattedMessage id='frontend.form_selector_addressbook.select.option.personal' />
                                    : <FormattedMessage id='frontend.form_selector_addressbook.select.option.shared' />
                                }</TableCell>
                                <TableCell className={styles.cell}>{ addressbook.get('type') === 'addressbook.shared' ? (
                                    <Button size='small' link to={'/addressbook/manage/' + addressbook.get('id')}>
                                        <FormattedMessage id='addressbook.address.manage_shared' />
                                    </Button>
                                ) : null }</TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Page.Section>
            </Page.Body>
        );
    }
}

export default connect(state => ({
    addressbooks: selectAddressbooks(state),
}))(AddressbookList);
